import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { CheckCircleIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

function VerificationSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state;

  // Redirect if no data
  useEffect(() => {
    if (!data) {
      navigate('/register');
    }
  }, [data, navigate]);

  if (!data) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500">
      <div className="container mx-auto px-4 h-full">
        <div className="flex content-center items-center justify-center min-h-screen py-12">
          <div className="w-full lg:w-5/12 px-4">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-2xl bg-white border-0">
              <div className="rounded-t-2xl mb-0 px-8 pt-8">
                <div className="text-center mb-3">
                  <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-4">
                    <CheckCircleIcon className="h-8 w-8 text-green-600" />
                  </div>
                  <h1 className="text-3xl font-bold text-gray-900 mb-2">
                    Phone Verified!
                  </h1>
                  <p className="text-gray-600 text-sm mb-4">
                    {data.message}
                  </p>
                </div>
              </div>

              <div className="flex-auto px-8 pb-8 pt-0">
                {data.requiresEmailVerification ? (
                  <div className="text-center space-y-4">
                    <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 mb-4">
                      <EnvelopeIcon className="h-6 w-6 text-blue-600" />
                    </div>
                    <div className="space-y-2">
                      <h3 className="text-lg font-medium text-gray-900">One More Step</h3>
                      <p className="text-sm text-gray-600">
                        We've sent an email verification link to <strong>{data.email}</strong>.
                        Please check your email and click the verification link to complete your registration.
                      </p>
                      <p className="text-xs text-gray-500">
                        After verifying your email, you'll be able to log in to your account.
                      </p>
                    </div>
                    
                    <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mt-4">
                      <h4 className="text-sm font-medium text-blue-900 mb-2">What's next?</h4>
                      <ol className="text-xs text-blue-800 space-y-1 list-decimal list-inside">
                        <li>Check your email inbox for a verification link</li>
                        <li>Click the verification link in the email</li>
                        <li>Return to the login page and sign in</li>
                      </ol>
                    </div>
                  </div>
                ) : (
                  <div className="text-center space-y-4">
                    <div className="space-y-2">
                      <h3 className="text-lg font-medium text-gray-900">Registration Complete!</h3>
                      <p className="text-sm text-gray-600">
                        Your account has been successfully created and verified.
                        You can now log in to your CF Ride Share account.
                      </p>
                    </div>
                  </div>
                )}

                <div className="text-center mt-8">
                  <Link
                    to="/login"
                    className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-xl text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-200"
                  >
                    Go to Login
                  </Link>
                </div>

                <div className="text-center mt-4">
                  <p className="text-xs text-gray-500">
                    Having trouble? Contact support at support@cfrideshare.com
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerificationSuccess; 